<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">进项发票</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <Tabs :datas="tabDatas" v-model="tab" @change="onTab" class-name="h-tabs-card"></Tabs>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">发票状态：</span>
            <Select v-model="invoiceStatus" :datas="statusOptions" keyName="value" titleName="title"
                    :deletable="false" style="width:130px" @change="loadList"></Select>
            <input type="text" v-model="keyword" placeholder="发票号码/供应商名称" class="input-small" @keyup.enter="loadList">
            <Button size="s" @click="loadList">刷新</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">新增进项发票</Button>
            <Button size="s" @click="notOpen('一键取票')">一键取票</Button>
            <DropdownMenu button @click="triggerIo" :datas="ioMenus" size="s">导入/导出</DropdownMenu>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">批量操作</Button>
            <Button size="s" :disabled="!checkedList.length" @click="generateVoucher">生成凭证</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="min-width:110px">发票种类</th>
                    <th style="min-width:120px">发票号码</th>
                    <th style="width:80px">状态</th>
                    <th style="min-width:90px">业务类型</th>
                    <th style="width:100px">开票日期</th>
                    <th style="min-width:130px">供应商名称</th>
                    <th style="min-width:130px">商品名称</th>
                    <th style="width:110px;text-align:right">合计金额</th>
                    <th style="width:70px">税率</th>
                    <th style="width:110px;text-align:right">合计税额</th>
                    <th style="width:110px;text-align:right">价税合计</th>
                    <th style="min-width:110px">备注</th>
                    <th style="min-width:110px">发票代码</th>
                    <th style="width:100px">业务日期</th>
                    <th style="min-width:90px">关联凭证</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody v-if="tab==='list'">
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked" :disabled="!!item.voucherId"></td>
                    <td>{{item.invoiceType}}</td>
                    <td>{{item.invoiceNo}}</td>
                    <td>{{statusText(item.invoiceStatus)}}</td>
                    <td>{{item.businessType}}</td>
                    <td>{{item.invoiceDate}}</td>
                    <td>{{item.supplierName}}</td>
                    <td>{{goods(item)}}</td>
                    <td align="right">{{item.amountExclTax|numFormat}}</td>
                    <td>{{rateText(item)}}</td>
                    <td align="right">{{item.taxAmount|numFormat}}</td>
                    <td align="right">{{item.amountInclTax|numFormat}}</td>
                    <td>{{item.remark}}</td>
                    <td>{{item.invoiceCode}}</td>
                    <td>{{item.businessDate}}</td>
                    <td class="text-hover">{{item.voucherWord}}{{item.voucherCode||''}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length"><td :colspan="17" class="text-center padding">暂无数据</td></tr>
                <tr class="total" v-if="datas.length">
                    <td :colspan="8" align="center">小计</td>
                    <td align="right">{{sumAmountExclTax|numFormat}}</td>
                    <td></td>
                    <td align="right">{{sumTax|numFormat}}</td>
                    <td align="right">{{sumAmountIncl|numFormat}}</td>
                    <td :colspan="6"></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="(row,i) in detailRows" :key="i">
                    <td></td>
                    <td>{{row.invoiceType}}</td>
                    <td>{{row.invoiceNo}}</td>
                    <td></td>
                    <td></td>
                    <td>{{row.invoiceDate}}</td>
                    <td>{{row.supplierName}}</td>
                    <td>{{row.goodsName}}</td>
                    <td align="right">{{row.amount|numFormat}}</td>
                    <td>{{row.taxRateText}}</td>
                    <td align="right">{{row.taxAmount|numFormat}}</td>
                    <td></td>
                    <td>{{row.remark}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-if="!detailRows.length"><td :colspan="17" class="text-center padding">暂无明细</td></tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id?'编辑':'新增'}}进项发票</div>
            <Form ref="form" v-width="480" :labelWidth="120" :model="form" :rules="rules">
                <FormItem label="发票种类">
                    <Select v-model="form.invoiceType" :datas="invoiceTypeOptions" :deletable="false"></Select>
                </FormItem>
                <FormItem label="业务类型"><input type="text" v-model="form.businessType" placeholder="如：采购货物"></FormItem>
                <FormItem label="业务日期" prop="businessDate"><DatePicker v-model="form.businessDate" format="yyyy-MM-dd"></DatePicker></FormItem>
                <FormItem label="开票日期" prop="invoiceDate"><DatePicker v-model="form.invoiceDate" format="yyyy-MM-dd"></DatePicker></FormItem>
                <FormItem label="发票号码" prop="invoiceNo"><input type="text" v-model="form.invoiceNo"></FormItem>
                <FormItem label="发票代码"><input type="text" v-model="form.invoiceCode"></FormItem>
                <FormItem label="供应商名称" prop="supplierName"><input type="text" v-model="form.supplierName"></FormItem>
                <FormItem label="统一社会信用代码"><input type="text" v-model="form.supplierTaxNo"></FormItem>
                <FormItem label="发票状态">
                    <Select v-model="form.invoiceStatus" :datas="statusOptions" keyName="value" titleName="title" :deletable="false"></Select>
                </FormItem>
                <FormItem label="是否录入明细">
                    <Radio v-model="form.hasDetail" :datas="[{value:1,title:'是'},{value:0,title:'否'}]"></Radio>
                </FormItem>
                <template v-if="form.hasDetail===1">
                    <FormItem label="商品明细">
                        <Button size="xs" color="primary" @click="addItem">添加行</Button>
                    </FormItem>
                    <table class="sub-grid">
                        <thead>
                        <tr><th>商品名称</th><th>规格</th><th>单位</th><th>数量</th><th>金额(不含税)</th><th>税率</th><th>税额</th><th></th></tr>
                        </thead>
                        <tbody>
                        <tr v-for="(it,i) in form.items" :key="i">
                            <td><input type="text" v-model="it.goodsName"></td>
                            <td><input type="text" v-model="it.spec"></td>
                            <td><input type="text" v-model="it.unit"></td>
                            <td><NumberInput v-model="it.qty" :precision="2" :min="0" style="width:70px"></NumberInput></td>
                            <td><NumberInput v-model="it.amount" :precision="2" :min="0" style="width:90px" @change="calcItem(it)"></NumberInput></td>
                            <td><NumberInput v-model="it.taxRate" :precision="4" :min="0" style="width:70px" @change="calcItem(it)"></NumberInput></td>
                            <td align="right">{{it.taxAmount|numFormat}}</td>
                            <td><span class="del" @click="form.items.splice(i,1)">删</span></td>
                        </tr>
                        </tbody>
                    </table>
                </template>
                <FormItem label="不含税金额"><NumberInput v-model="form.amountExclTax" :precision="2" :min="0"></NumberInput></FormItem>
                <FormItem label="税额"><NumberInput v-model="form.taxAmount" :precision="2" :min="0"></NumberInput></FormItem>
                <FormItem label="价税合计"><NumberInput v-model="form.amountInclTax" :precision="2" :min="0"></NumberInput></FormItem>
                <FormItem label="发票附件"><Button size="xs" @click="notOpen('上传附件')">上传</Button></FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit(false)" :loading="loading">保存</Button>
                <Button color="primary" @click="submit(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>

        <import-modal v-model="showImport" title="进项发票导入" templateUrl="/api/invoice-income/template"
                      :import-fn="importIncome" @success="loadList"/>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';
import { exportXls } from '../../js/common/export';

const emptyForm = () => ({
    id: null, invoiceType: '数电票（普通发票）', businessType: '', businessDate: new Date(), invoiceDate: new Date(),
    invoiceNo: '', invoiceCode: '', supplierName: '', supplierTaxNo: '', invoiceStatus: 1, hasDetail: 1,
    amountExclTax: 0, taxAmount: 0, amountInclTax: 0, remark: '', items: []
});

export default {
    name: 'IncomeInvoice',
    components: { ImportModal },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [],
            tab: 'list',
            tabDatas: { list: '进项发票', detail: '商品明细' },
            p1: ym, p2: ym, keyword: '', invoiceStatus: null,
            invoiceTypeOptions: [],
            statusOptions: [
                { value: 1, title: '正常' }, { value: 2, title: '作废' },
                { value: 3, title: '全额红冲' }, { value: 4, title: '部分红冲' }
            ],
            showForm: false, loading: false, form: emptyForm(),
            showImport: false,
            ioMenus: [
                { title: '模板导入', key: 'openImport' },
                { title: '当前数据导出', key: 'exportCurrent' },
                { title: '全部数据导出', key: 'exportAll' }
            ],
            rules: { required: ['businessDate', 'invoiceDate', 'invoiceNo', 'supplierName'] }
        };
    },
    computed: {
        checkAll() { return this.datas.length > 0 && this.datas.every(d => d._checked); },
        checkedList() { return this.datas.filter(d => d._checked); },
        detailRows() {
            const rows = [];
            this.datas.forEach(o => {
                (o.items || []).forEach(it => rows.push({
                    invoiceType: o.invoiceType, invoiceNo: o.invoiceNo, invoiceDate: o.invoiceDate,
                    supplierName: o.supplierName, goodsName: it.goodsName, amount: it.amount,
                    taxRateText: this.fmtRate(it.taxRate), taxAmount: it.taxAmount, remark: o.remark
                }));
            });
            return rows;
        },
        sumAmountExclTax() { return this.datas.reduce((s, d) => s + Number(d.amountExclTax || 0), 0); },
        sumTax() { return this.datas.reduce((s, d) => s + Number(d.taxAmount || 0), 0); },
        sumAmountIncl() { return this.datas.reduce((s, d) => s + Number(d.amountInclTax || 0), 0); }
    },
    methods: {
        fmtPeriod(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; },
        fmtDate(d) { if (!d) return ''; if (typeof d === 'string') return d; return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; },
        fmtRate(r) { if (r == null) return '-'; return (Number(r) * 100).toFixed(2) + '%'; },
        statusText(v) { return ({ 1: '正常', 2: '作废', 3: '全额红冲', 4: '部分红冲' })[v] || '-'; },
        rateText(item) { const it = (item.items || [])[0]; return this.fmtRate(it && it.taxRate); },
        goods(item) { const its = item.items || []; return its.length ? its.map(i => i.goodsName).join(',') : ''; },
        loadOptions() {
            this.$api.invoice.income.options().then(({ data }) => {
                this.invoiceTypeOptions = (data || []).map(t => ({ title: t, key: t }));
                this.loadList();
            });
        },
        loadList() {
            this.$api.invoice.income.list({
                p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2),
                keyword: this.keyword || undefined, invoiceStatus: this.invoiceStatus || undefined
            }).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({ _checked: false }, d));
            });
        },
        onTab() { this.loadList(); },
        add() { this.form = emptyForm(); this.showForm = true; },
        edit(item) {
            const f = Object.assign(emptyForm(), item);
            f.businessDate = item.businessDate ? new Date(item.businessDate) : new Date();
            f.invoiceDate = item.invoiceDate ? new Date(item.invoiceDate) : new Date();
            f.items = item.items ? item.items.map(i => Object.assign({}, i)) : [];
            this.form = f;
            this.showForm = true;
        },
        addItem() { this.form.items.push({ goodsName: '', spec: '', unit: '', qty: 0, amount: 0, taxRate: 0, taxAmount: 0 }); },
        calcItem(it) { const r = Number(it.taxRate || 0); it.taxAmount = (Number(it.amount || 0) * r).toFixed(2); },
        submit(keep) {
            if (!this.$refs.form.valid().result) return;
            const p = Object.assign({}, this.form);
            p.businessDate = this.fmtDate(p.businessDate);
            p.invoiceDate = this.fmtDate(p.invoiceDate);
            if (p.hasDetail !== 1) p.items = [];
            this.loading = true;
            this.$api.invoice.income[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false;
                this.loadList();
                this.$Message.success('保存成功');
                if (keep) { this.form = emptyForm(); } else { this.showForm = false; }
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm('确认删除该发票?').then(() => {
                this.$api.invoice.income.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 条记录?`).then(() => {
                Promise.all(ids.map(id => this.$api.invoice.income.delete(id))).then(() => this.loadList());
            });
        },
        generateVoucher() {
            const ids = this.checkedList.map(d => d.id);
            this.$api.invoice.income.generateVoucher(ids).then(({ msg }) => {
                this.$Message.success(msg || '已生成凭证');
                this.loadList();
            });
        },
        toggleAll() { const v = !this.checkAll; this.datas.forEach(d => { if (!d.voucherId) d._checked = v; }); },
        triggerIo(key) { this[key].call(this); },
        openImport() { this.showImport = true; },
        importIncome(fd) { return this.$api.invoice.income.importData(fd); },
        head() {
            return ['发票种类', '发票号码', '状态', '业务类型', '开票日期', '供应商名称', '商品名称', '合计金额', '税率', '合计税额', '价税合计', '备注', '发票代码', '业务日期'];
        },
        buildRows(list) {
            return (list || []).map(d => [
                d.invoiceType, d.invoiceNo, this.statusText(d.invoiceStatus), d.businessType, d.invoiceDate, d.supplierName,
                this.goods(d), Number(d.amountExclTax || 0), this.rateText(d), Number(d.taxAmount || 0), Number(d.amountInclTax || 0),
                d.remark, d.invoiceCode, d.businessDate
            ]);
        },
        totalOf(list) {
            const s = (list || []).reduce((o, d) => { o.a += Number(d.amountExclTax || 0); o.t += Number(d.taxAmount || 0); o.i += Number(d.amountInclTax || 0); return o; }, { a: 0, t: 0, i: 0 });
            return ['合计', '', '', '', '', '', '', s.a, '', s.t, s.i, '', '', ''];
        },
        exportCurrent() {
            if (!this.datas.length) { this.$Message('暂无数据可导出'); return; }
            exportXls({
                name: `进项发票_${this.fmtPeriod(this.p1)}至${this.fmtPeriod(this.p2)}`,
                sheets: [{ name: '进项发票', head: this.head(), rows: this.buildRows(this.datas), totalRow: this.totalOf(this.datas),
                    widths: [110, 120, 80, 90, 100, 130, 130, 110, 70, 110, 110, 110, 110, 100],
                    types: ['s','s','s','s','s','s','s','n','s','n','n','s','s','s'] }]
            });
        },
        exportAll() {
            this.$api.invoice.income.list({ all: 1 }).then(({ data }) => {
                const list = data || [];
                if (!list.length) { this.$Message('暂无数据可导出'); return; }
                exportXls({
                    name: '进项发票_全部数据',
                    sheets: [{ name: '进项发票', head: this.head(), rows: this.buildRows(list), totalRow: this.totalOf(list),
                        widths: [110, 120, 80, 90, 100, 130, 130, 110, 70, 110, 110, 110, 110, 100],
                        types: ['s','s','s','s','s','s','s','n','s','n','n','s','s','s'] }]
                });
            });
        },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); }
    },
    mounted() { this.loadOptions(); }
};
</script>

<style scoped lang="less">
.filter-bar {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    .label { margin-left: 6px; }
    .flex-spacer { flex: 1; }
    .input-small { width: 160px; height: 30px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 8px; }
}

.grid {
    width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
    .total td { background-color: #f5f5f5; font-weight: bold; }
}

.sub-grid {
    width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 8px;
    th, td { border: 1px solid #e2e2e2; padding: 2px 4px; height: 30px; }
    th { background-color: #f5f5f5; text-align: center; }
    input[type=text] { width: 90px; height: 26px; border: 1px solid #d9d9d9; border-radius: 3px; padding: 0 4px; }
}

.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
.del { cursor: pointer; color: #f44336; }
.text-hover { cursor: pointer; }
</style>
